<template>
  <div v-if="venueIds == null">
    <span>Please make sure you select a facility first</span>
  </div>

  <div class="top-menu" v-else>
    <div class="flex-container-menu">
      <div class="flex-child-menu">
        <base-menu
          id="facility-search"
          @click="selectedTabMethod('stored-resources')"
          :mode="storedRestButtonMode"
          disabled
          >SEARCH</base-menu
        >
      </div>
      <div class="flex-child-menu">
        <base-menu
          @click="selectedTabMethod('add-contact')"
          :mode="addResButtonMode"
          disabled
          >DETAILS</base-menu
        > 
        
        <!-- :disabled="venueIds == null"  -->
      </div>
      <div class="flex-child-menu">
        <base-menu
          @click="selectedTabMethod('payment-page')"
          :mode="paymentButtonMode"
          disabled
          >PAYMENT</base-menu
        >
        
        <!-- :disabled="!bookingConfirmStatus"  -->
      </div>
      <div class="flex-child-menu">
        <base-menu
          @click="selectedTabMethod('booking-summary')"
          :mode="bookingSummaryButtonMode"
          disabled
          >CONFIRMATION
        </base-menu>
      </div>
    </div>

    <base-card
      v-if="sessionStart"
      class="timer-text"
      :style="{
        backgroundColor: myclass,
        color: myText,
      }"
    >
      <p>
        this booking session will expire in
        <b>
          0{{ Math.floor(timerCountDown / 60) }} :
          {{ displaySecondsIssueFixer() }}</b
        >
      </p>
    </base-card>
    <div v-if="isFCHQ" v-show="selectedTab == 'stored-resources'">
      <fchq @venues-selected="venuesSelected"></fchq>
    </div>
    <keep-alive>
      <component
        :is="selectedTab"
        :solutions="sendDataBySelectedTab"
      ></component>
    </keep-alive>
  </div>
</template>

<script>
import TennisPage from './TennisPage.vue';
import StoredResources from './StoredResources.vue';
import AddContact from './AddContact.vue';
import PaymentPage from './PaymentPage.vue';
import BookingSummary from './BookingSummary.vue';
import BaseMenu from '../UI/BaseMenu.vue';

import { tokenAPI, localToken, Envs } from '../../../../config';
import { Tennis } from '../data';

export default {
  components: {
    StoredResources,
    AddContact,
    PaymentPage,
    BookingSummary,
    BaseMenu,
    TennisPage
},
  data() {
    return {
      link: Envs.local,
      isback: false,
      isBusiness: false,
      selectedTab: 'stored-resources',
      selectedItem: null,

      sessionStart: false,

      newUser: null,
      priceCatalogue: 'hourly',

      contactId: null,

      bookingConfirmStatus: false,

      bookingDetails: null,

      paymentSolutions: null,

      solutions: null,

      payment: null,

      confirmedBookingDetails: null,

      originalRequestBookingDetails: null,

      token: '',

      bookingCharges: null,

      venueIds: null,
      venuesObject: null,
      pickedConfig: null,

      currentRoute: null,
      currentPath: null,

      isFCHQ: false,

      splashPageLoaded: true,

      faclityName: 'Booking',

      currentEnv: Envs,

      mytk: null,

      // create a lot of data here for booking, and accept all client's data ready for booking

      timerCountDown: 240,
      myclass: 'lightgrey',
      myText: 'black',
      mytransparency: 100,
      ticker: null,
      timerShow: false,
      r: 255,
      g: 255,
      b: 255,
    };
  },

  provide() {
    return {
      // provide method

      getToken: this.returnToken,

      // setPaymentSolutions: this.setPaymentSolutionsMethod,

      addNewUserMethod: this.addUser,

      selectedResource: this.selectedResource,

      setSelectedTag: this.selectedTabMethod,

      resetPrevData: this.resetAllPrevBookingData,

      getNewUser: this.returnNewUser,

      getBookingDetails: this.getBookingDetails,

      getBookingConfirmStatus: this.getBookingConfirmStatus,

      setConfirmedBookingDetails: this.setConfirmedBookingDetailsMethod,

      getConfirmedBookingDetails: this.getConfirmedBookingDetails,

      setBookingCharges: this.setBookingCharges,
    };
  },

  watch: {
    timerCountDown() {
      return this.myclass;
    },
    mytk() {
      //    console.log('my token....', this.mytk);

      this.getInit(this.mytk);
    },
    currentRoute() {
      this.currentPath = this.currentRoute.path;
    },

    currentPath() {
        this.venuesObject = Tennis;
        this.venueIds = Tennis.venueIds;
        this.isBusiness = false;
    },

    contactId(value) {
      if (value > 0) {
        //    console.log('printing watch');
      }
    },

    confirmedBookingDetails() {
      //  console.log(
      //    'updated confimed booking details',
      //    this.confirmedBookingDetails
      //   );
    },
  },

  computed: {
    styles: function () {
        return {
          'background-color': '#00509e',
        };
    },

    sendDataBySelectedTab() {
      if (this.selectedTab === 'payment-summary') {
        return {
          payment: this.payment,
          user: this.user,
          isBusiness: this.isBusiness,
          env: this.currentEnv,
        };
      } else if (this.selectedTab === 'payment-page') {
        //TODO , adding those layoutnotes addtional notes to the user

        if (!this.bookingConfirmStatus) return;
        return {
          account: this.venuesObject.account,
          rtype: this.venuesObject.rtype,
          selectedVenue: this.bookingDetails,
          user: this.newUser,
          additionalRequirements: this.pickedConfig,
          env: this.currentEnv,
        };
      } else if (this.selectedTab === 'booking-summary') {
        //TODO , adding those layoutnotes addtional notes to the user

        return {
          payment: this.payment,
          selectedVenue: this.bookingDetails,
          bookingconfirmdetails: this.confirmedBookingDetails,
          user: this.newUser,
          originalBookingReq: this.originalRequestBookingDetails,
          additionalRequirements: this.pickedConfig,
          isBusiness: this.isBusiness,
          env: this.currentEnv,
        };
      } else if (
        this.selectedTab === 'stored-resources' ||
        this.selectedTab === 'add-contact'
      ) {
         console.log('return token when tab ', this.venuesObject);

        this.$eventBus.emit('search-again', []);

        return {
          token: this.returnToken(),
          bookingDetails: this.bookingDetails,
          pc: this.priceCatalogue,
          venueObj: this.venuesObject,
          // user: this.newUser,
          isBusiness: this.isBusiness,
          env: this.currentEnv,
        };
      } else {
        return null;
      }
    },

    storedRestButtonMode() {
      return this.selectedTab === 'stored-resources' ? null : 'flat';
    },

    addResButtonMode() {
      return this.selectedTab === 'add-contact' ? null : 'flat';
    },

    paymentButtonMode() {
      return this.selectedTab === 'payment-page' ? null : 'flat';
    },

    bookingSummaryButtonMode() {
      return this.selectedTab === 'booking-summary' ? null : 'flat';
    },
  },

  mounted() {
    // send all data to be save and save the booking
      // console.log('send confirm booking payment', payment);
    this.$eventBus.on('paymentApproved', (payment) => {
      console.log('send confirm booking payment', payment);
      this.payment = payment;
      clearInterval(this.ticker);
      this.sessionStart = false;
    });

    this.$eventBus.on('resetSession', () => this.onSessionReset());
    this.$eventBus.on('search-submit', () => this.onSessionRestart());
  },

  beforeMount() {
    this.currentEnv = Envs;
    this.mytk = this.currentEnv.tokenUrl;
    this.currentRoute = this.$router.currentRoute;
  },

  methods: {
    onSessionRestart() {
      clearInterval(this.ticker);
      this.sessionStart = false;
      this.timerCountDown = 240;
    },

    onSessionReset() {
      this.myclass = 'lightgrey';
      this.myText = 'black';
      this.solutions = null;

      this.bookingConfirmStatus = false;
      this.bookingDetails = null;
      this.bookingCharges = [];
      this.sessionStart = false;
      this.timerCountDown = 240;
      // console.log('here is the reset...');
      this.selectedTab = 'stored-resources';
      clearInterval(this.ticker);
    },

    venuesSelected(venues) {
       console.log('venue selected ', venues);
      this.venueIds = venues.VenueDetails.venueIds;
      this.venuesObject = venues.VenueDetails;
      this.pickedConfig = venues.PickedConfig;

      this.$eventBus.emit('resetSession', []);
    },

    returnToken() {
      return this.token;
    },

    getInit(tkurl) {
      //   console.log('TOKEN INIT here ');

      var requestOptions = {
        method: 'GET',
        redirect: 'follow',
      };

      fetch(tkurl + tokenAPI, requestOptions)
        .then((response) => {
          return response.text();
        })
        .then((result) => {
          //   console.log('my init token ---', result);
          this.token = result;
          //TODO
        })
        .catch((error) => {
          console.log('token error the resources ', error);
          this.token = localToken;

          //      console.log('local token ', localToken);
        });
    },

    setBookingCharges(charges) {
      //  console.log('set booking charges ', charges);
      this.bookingCharges = charges;
    },

    // setPaymentSolutionsMethod(paymentSolutions) {
    //  this.payment = paymentSolutions;

    //  console.log('solutions ', this.payment);
    //},

    getConfirmedBookingDetails() {
      return this.confirmedBookingDetails;
    },

    setConfirmedBookingDetailsMethod(
      confirmedBookingDetails,
      requestedBookingDetails
    ) {
      this.confirmedBookingDetails = confirmedBookingDetails;
      this.originalRequestBookingDetails = requestedBookingDetails;

      return (this.selectedTab = 'booking-summary');
    },

    resourceHolder() {},

    getBookingConfirmStatus() {
      return {
        bkStatus: this.bookingConfirmStatus,
        bkDetails: this.bookingDetails,
        bkCharges: this.bookingCharges,
        token: this.token,
        smartPriceID: this.venuesObject.pricingCatalogue[this.priceCatalogue], // TODO , this is to be set a default for facility booking ( this is to be able for user to pick from or calculate by FE)
      };
    },

    getBookingDetails(bookingDetails, priceCatalogue) {
      // return;
      this.bookingConfirmStatus = true;
      this.priceCatalogue = priceCatalogue;

      //TODO this is a hack to assign isBusiness into selectedVenue
      //piggy back method, not recommended.
      let bkDetails = Object.assign({}, bookingDetails);

      bkDetails.IsBusiness = this.isBusiness;
      bkDetails.StartTime = bkDetails.StartDate;
      bkDetails.EndTime = bkDetails.EndDate;
      bkDetails.Notes = '';
      if (this.pickedConfig !== null) {
        bkDetails.Notes =
          '>>> special requirement >>> : \n\n\n\n ' +
          JSON.stringify(this.pickedConfig);
      }

      bkDetails.OpportunityId = 0;
      this.bookingDetails = bkDetails;

      /*
      console.log(
        'this request price catalogue',
        priceCatalogue,
        this.bookingDetails
      );
*/
      this.selectedTab = 'add-contact';
      this.timerRunner();
    },

    returnNewUser() {
      return this.newUser;
    },

    addUser(newUser) {
      //this.storedResources.unshift(newRes);
      // console.log('new user', newUser);

      // this is only for record purpose for detain the details of a booking in case if a booking failed.
      //console.log('new user ', newUser);
      if (newUser.oid !== null) {
        this.newUser = newUser;
        this.contactId = newUser.id;
        this.bookingDetails.OpportunityId = newUser.oid;
        this.selectedTab = 'payment-page';
      }
    },

    selectedTabMethod(tab) {
      this.selectedTab = tab;
    },

    selectedResource(resId, child) {
      console.log('select resources', resId, child);
      this.selectedTab = 'stored-resources';
    },

    // below are clock related

    displaySecondsIssueFixer() {
      const currentSec = this.timerCountDown % 60;

      if (currentSec < 10) {
        return '0' + currentSec;
      } else return currentSec;
    },

    timerRunner() {
      this.sessionStart = true;
      this.ticker = setInterval(this.runCountDown, 1000);
    },

    runCountDown() {
      this.timerCountDown = this.timerCountDown - 1;

      if (this.timerCountDown < 180 && this.timerCountDown > 60) {
        this.myclass = 'orange';
        this.myText = 'black';
        const val = 80 - (this.timerCountDown % 60);
        this.mytransparency = val + '%';
      } else if (this.timerCountDown < 60) {
        this.myclass = 'red';
        const val = 100 - this.timerCountDown;

        this.myText = 'white';
        if (this.timerCountDown < 31) {
          const odd = val % 2;
          if (odd === 0) {
            this.myText = 'black';
          } else {
            this.myText = 'white';
          }
        }
        this.mytransparency = val + '%';
      }

      if (this.timerCountDown <= 1) {
        this.$eventBus.emit('resetSession', null);
      }
    },
  },
};
</script>

<style>
.box {
  margin-top: 3rem;
  width: 100%;
  height: 80px;
  background-color: #c9c2c0;
}

/* Tooltip container */
.tooltip {
  position: relative;
  display: inline-block;
  border-bottom: 1px dotted black; /* If you want dots under the hoverable text */
}

/* Tooltip text */
button.tooltip .tooltiptext {
  word-wrap: break-word;
  visibility: hidden;
  width: 150px;
  background-color: #6882d6;
  color: rgb(255, 255, 255);
  text-align: center;
  padding: 5px 0;
  border-radius: 6px;

  /* Position the tooltip text - see examples below! */
  position: absolute;
  z-index: 1;
}

/* Show the tooltip text when you mouse over the tooltip container */
button.tooltip:hover .tooltiptext {
  visibility: visible;
}

/* Show the tooltip text when you mouse over the tooltip container */
button.tooltip:focus .tooltiptext {
  visibility: hidden;
}

#timerlbl {
  color: red;
}

.fulltime {
  background-color: #30b371;
}

.halftime {
  background-color: #dbb50a;
}

.critial {
  background-color: #ec3169;
}

.timer-text {
  text-align: center;
  margin: unset;
}

.card-underlayer {
  z-index: 1;
}
.card-position {
  background-color: #c9c2c0;
  z-index: 2;
}

.cancel-style {
  border-radius: 0px;
  box-shadow: none;
}

.top-menu {
  margin: 2rem auto;
  max-width: 50rem;
}

.flex-container-menu {
  display: flex;
  flex-direction: row;
}

.flex-child-menu {
  border: 2px solid rgb(255, 255, 255);
  margin-right: 0px;
}

.flex-child-menu:first-child {
  margin-left: 0;
}

@media (max-width: 768px) {
  .top-menu {
    margin: 1rem auto;
  }

  .flex-child-menu {
    margin-left: 0;
    flex: 1;
  }
}
</style>
